import React from 'react';

import { cn, Form } from '@crossnokaye/ux-common';

import { BottomStickyPortal } from '@/components/app-layout/components/bottom-sticky-portal';
import { EquipmentDetailsDefrostSchedule } from '@/features/equipment-browser/equipment-details/defrost-schedule/equipment-details-defrost-schedule';
import { EquipmentDetailsSettings } from '@/features/equipment-browser/equipment-details/settings/equipment-details-settings';
import { EquipmentDetailsSubcomponents } from '@/features/equipment-browser/equipment-details/subcomponents/equipment-details-subcomponents';
import { SequencerSection } from '@/features/equipment-browser/sequencer-section/sequencer-section';
import { Stack } from '@/ux-common/components/stack/stack';

import { EquipmentDetailsFormSaveBar } from './components/equipment-details-form-save-bar';
import { useDetailsForm } from './hooks/use-details-form';

/**
 * EquipmentDetailsForm
 *
 * Root form component for managing all equipment details including settings,
 * subcomponents, sequencer configuration, and defrost schedules. Provides a unified
 * form context with automatic save bar visibility based on form dirty state.
 *
 * @returns The complete equipment details form with all subsections and save controls
 */
export const EquipmentDetailsForm = (): React.ReactElement => {
  const { form, resetForm } = useDetailsForm();
  return (
    <Form {...form}>
      <form id={'equipment-details-form'} className={cn('overflow-hidden h-full')}>
        <Stack className="stack-thin">
          <EquipmentDetailsSettings />
          <SequencerSection />
          <EquipmentDetailsSubcomponents />
          <EquipmentDetailsDefrostSchedule />
        </Stack>

        <BottomStickyPortal>
          <EquipmentDetailsFormSaveBar onDiscard={resetForm} />
        </BottomStickyPortal>
      </form>
    </Form>
  );
};
